
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import CollapsableSidebar from './CollapsableSidebar';
import PullDownMenu from './PullDownMenu';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { setRemovePullDownMenu } from '../../../../state/actions/tabStack';


export const MenuIcon = ({ currentTabName, currentBotName, isAssistantBotOpen, showFavoritesIcon, isFavoriteBot, handleSetFavorite }) => {
    const isSideBar = useSelector((state) => state.layout.isSideBar);
    const { selectedConversation } = useSelector((state) => state.chats);
    const conversationId = selectedConversation?.conversationId;
    const tabStack = useSelector(state => state.tabStack[conversationId || ""]);
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== "/app/chats" && conversationId) {
            dispatch(setRemovePullDownMenu(conversationId))
        }
    }, [location.pathname]);

    return (
        <div>
            {
                !isEmpty(tabStack) && !isEmpty(tabStack.pullDownMenuComponent) && !isAssistantBotOpen ?
                    <PullDownMenu
                        isSideBar={isSideBar}
                        currentBotName={currentBotName}
                        pullDownMenuComponent={tabStack.pullDownMenuComponent}
                        dispatch={dispatch}
                        showFavoritesIcon={showFavoritesIcon}
                        isFavoriteBot={isFavoriteBot}
                        handleSetFavorite={handleSetFavorite}
                    />
                    :
                    <CollapsableSidebar
                        isSideBar={isSideBar}
                        currentTabName={currentTabName}
                        currentBotName={currentBotName}
                        dispatch={dispatch}
                        showFavoritesIcon={showFavoritesIcon}
                        isFavoriteBot={isFavoriteBot}
                        handleSetFavorite={handleSetFavorite}
                    />
            }
        </div>
    )
};
